<template>
  <h1>404页面不存在</h1>
</template>

<script setup>
const resetLink = () => {
  //window.location.href = 'https://www.stellantisafc.com.cn/'
}

resetLink();
</script>
